/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog[_ngcontent-%COMP%]{z-index:1000;position:fixed;right:0;left:0;top:200px;margin-right:auto;margin-left:auto;min-height:300px;width:40%;max-width:60%;background-color:#fff;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12)}.header[_ngcontent-%COMP%]{height:65px;background-color:#101244}.close[_ngcontent-%COMP%]{color:#fff;opacity:1}.top-15[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };
